import { forwardRef, createElement } from 'react';

function IconNoteFollowUp(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M18.25 2c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0118.25 22H14v-1.5h4.25a.25.25 0 00.243-.193l.007-.057V3.75a.25.25 0 00-.193-.243L18.25 3.5H5.75a.25.25 0 00-.243.193L5.5 3.75V11H4V3.75C4 2.784 4.784 2 5.75 2h12.5zM9.225 20.974A1.259 1.259 0 018 22c-.605 0-1.11-.44-1.225-1.026h2.45zM8 12c.456 0 .841.392.961.927A3 3 0 0111 15.769v2.898l.835.642a.5.5 0 01-.305.896H4.47a.5.5 0 01-.305-.896L5 18.667v-2.898c0-1.32.854-2.442 2.04-2.843.119-.534.504-.926.96-.926zm7.25 2.5a.75.75 0 110 1.5h-1.5a.75.75 0 110-1.5h1.5zm0-3.5a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zm0-3.5a.75.75 0 110 1.5h-6.5a.75.75 0 010-1.5h6.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var NoteFollowUp = /*#__PURE__*/forwardRef(IconNoteFollowUp);

export default NoteFollowUp;
//# sourceMappingURL=NoteFollowUp.js.map
